import { LabelText, LittleText } from "../../../../components/typography";
import { OnboardingBodyBlock } from "../settings";
import Input from "../../../../components/ui/inputs";
import { useOutletContext } from "react-router-dom";
import { OnboardingButtons } from "../../../../components/ui/button";

export default function NameStep() {
    const { name, setName } =
        useOutletContext<{ name: string; setName: React.Dispatch<React.SetStateAction<string>> }>();
    return (
        <OnboardingBodyBlock className="align-items-start mt-2">
            <LabelText>Назвіть вашу CRM</LabelText>
            <span className="pt-2">
                <LittleText>Ця назва буде відображатися для всієї команди та допоможе легко ідентифікувати ваш робочий простір.</LittleText>
                <LittleText className="accent-color">Ви зможете змінити її пізніше в налаштуваннях.</LittleText>
            </span>
            <Input
                attribute="nameOfCRM"
                value={name}
                setValue={setName}
                errorText={""}
                label=""
                placeholder="Введіть назву CRM"
            />
            <OnboardingButtons isBackBtn={false} state={!name} path="/onboarding/plan" />

        </OnboardingBodyBlock>
    )
}

